import React, { useContext, useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import { _t, getCookie } from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

import { BASE_URL } from "../../../../../BaseUrl";
import axios from "axios";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import Switch from "react-switch";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { ToastError, ToastSuccess } from "../../../../../functions/ToastShow";

const CurrencyNoteAction = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();

  // contexts
  const {
    loading,
    setLoading,
  } = useContext(SettingsContext);

  // states
  const [formData, setFormData] = useState({
    name: "",
    rate: "",
    status: 1,
  });

  useEffect(() => {
    if (id) {
      fetchData(id);
    }
  }, [id]);

  const fetchData = async (id) => {
    setLoading(true);
    const url = BASE_URL + `/settings/cash-note-types/${id}`;
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if (res.data) {
        setFormData({
          name: res.data.name,
          rate: res.data.value,
          status: parseInt(res.data.status),
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(`${_t(t("Failed to fetch data"))}`, {
        position: "bottom-center",
        autoClose: 5000,
      });
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatusChange = (checked) => {
    setFormData({
      ...formData,
      status: checked ? 1 : 0,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.rate) {
      toast.error(`${_t(t("Please fill all required fields"))}`, {
        position: "bottom-center",
        autoClose: 5000,
      });
      return;
    }

    setLoading(true);
    const url = id
      ? BASE_URL + `/settings/cash-note-types/${id}`
      : BASE_URL + `/settings/cash-note-types`;
    const method = id ? "put" : "post"
    const data = {
      name: formData.name,
      value: formData.rate,
      status: formData.status
    };

    try {
      const res = await axios[method](url, data, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      
      if (res.data) {
        ToastSuccess({ title: t(id ? "Bank Payment has been update" : "Bank Payment has been saved") });
        history.push("/dashboard/manage/settings/currency-note");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      ToastError({title: t("Something went wrong")})
    }
  };

  return (
    <>
      <Helmet>
        <title>{id ? _t(t("Edit Currency Note")) : _t(t("Add Currency Note"))}</title>
      </Helmet>

      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>

            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${loading && "loading"}`}></div>
                    <div key="smtp-form">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-12">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t((id) ? "Edit Currency Note" : "Add Currency Note"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <form
                        className="row card p-2 mx-3 mb-5 table-text"
                        onSubmit={handleSubmit}
                        autoComplete="off"
                      >
                        <div className="row">
                          <div className="col-5 mb-3">
                            <label htmlFor="name" className="form-label">
                              {_t(t("Name"))} <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="name"
                              name="name"
                              value={formData.name}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="col-4 mb-3">
                            <label htmlFor="rate" className="form-label">
                              {_t(t("Rate"))} <span className="text-danger">*</span>
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="rate"
                              name="rate"
                              value={formData.rate}
                              onChange={handleInputChange}
                              required
                            />
                          </div>
                          <div className="col-3 mb-3">
                            <label htmlFor="status" className="form-label d-block">
                              {_t(t("Status"))}
                            </label>
                            <Switch
                              onChange={handleStatusChange}
                              checked={formData.status === 1}
                              height={20}
                              width={40}
                            />
                          </div>
                        </div>

                        <div className="row mt-4">
                          <div className="col-12 d-flex justify-content-end align-items-center">
                            <button
                              type="button"
                              className="btn rounded hov-btn mr-3"
                              onClick={() => history.push("/dashboard/manage/settings/currency-note")}
                            >
                              <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Cancel"))}
                            </button>
                            <button
                              type="submit"
                              className="btn btn-primary rounded"
                              disabled={loading}
                            >
                              <i class="fa fa-floppy-o" aria-hidden="true"></i> {loading ? _t(t("Please wait...")) : _t(t("Submit"))}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default CurrencyNoteAction;
